<app-driver-activity [title]="'driverDashboard.widgets.stationaryDrivers' | transloco" [count]="count" [icon]="'ph-bus'" [columnHeaders]="columnHeaders"
  [filteredDriversData]="filteredDriversData" [isModal]="isModal" [componentId]="componentId"
  (toggleExpandEvent)="onExpand($event)" [isLoading]="isLoading" (scrollEvent)="onScroll()"
  [isPageLoading]="isFetching" [hasError]="hasError">
</app-driver-activity>
